export enum UserType {
  SUPER_TENANT = 'SUPER_TENANT',
  TENANT = 'TENANT',
  SUB_TENANT = 'SUB_TENANT',
}
